<template>
  <div class="col-6">
    <div class="card m-4">
      <h3 class="card-header text-center">
        {{ $t('first-run.new-company.heading') }}
      </h3>
      <div class="card-body text-center" style="height:250px">
        <p class="lead mt-5" v-html="$t('first-run.new-company.text')"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'NewCompany',
}
</script>
